module.exports = __webpack_public_path__ + "img/tc.0285f27b.jpg";